// import qs from "qs";
import http from "../http";

function logIn(payload) {
     return http("POST", `${window.API_URL}/login`, payload);
}

function logOut(payload) {
     return http("POST", `${window.API_URL}/logout`, payload);
}

function getMenus() {
    return http("GET", `${window.API_URL}/role/menu`);
}

function hasRole(payload) {
    return http("GET", `${window.API_URL}/role/${payload.menuCode}`);
}

function getInitAccount(payload) {
    return http("POST", `${window.API_URL}/initAccount`, payload);
}

function setActivateAccount(payload) {
    return http("PUT", `${window.API_URL}/activateAccount`, payload);
}

export default {
    logIn,
    logOut,
    getMenus,
    hasRole,
    getInitAccount,
    setActivateAccount,
};